module.exports = __webpack_public_path__ + "static/media/icon_close.73745110.svg";